import React, { Suspense } from 'react';

const LazyToolpathViewer3D = React.lazy(() => import('@/components/ToolpathViewer3D'));

const ToolpathViewer3DWrapper = (props) => {
  return (
    <Suspense
      fallback={
        <div style={{ height: props.height || 350 }} className="flex items-center justify-center bg-industrial-bg rounded-lg">
          <div className="w-6 h-6 border-2 border-blue-400/30 border-t-blue-400 rounded-full animate-spin" />
        </div>
      }
    >
      <LazyToolpathViewer3D {...props} />
    </Suspense>
  );
};

export default ToolpathViewer3DWrapper;
